<script>
import he from "he";

export default {
  name: "formationExtrait",
  props: {
    cpt: {
      type: Object,
    },

    texte_en_savoir_plus: {
      type: String,
    },

    dataJson: {
      type: Object,
    },
  },
  methods: {
    convertToFrenchDate(dateString) {
      if (dateString) {
        var date = new Date(
          dateString.slice(0, 4),
          dateString.slice(4, 6) - 1,
          dateString.slice(6)
        );
        var options = { year: "numeric", month: "short", day: "numeric" };
        return new Intl.DateTimeFormat("fr-FR", options).format(date);
      }
    },
    decode(string) {
      return string ? he.decode(string) : null;
    },
  },
};
</script>

<template>
  <div>
    <div class="terms-container">
      <template v-if="cpt.acf_fields">
        <p v-if="cpt.acf_fields.nouvelle_formation" class="nouvelle-formation">
          {{ dataJson.texte_pour_le_bandeau_de_nouvelle_formation }}
        </p>
      </template>
      <template v-for="term in cpt.terms" :key="term.term_id">
        <template v-if="term.taxonomy !== 'tri_pour_page_formation'">
          <span :class="'term term-' + term.taxonomy">
            {{ term.name }}
          </span>
        </template>
      </template>
      <template v-if="cpt.hasOwnProperty('_embedded')">
        <span v-if="cpt.acf_fields.champ_libre" class="term term-libre">
          {{ cpt.acf_fields.champ_libre }}
        </span>
      </template>
      <span v-if="cpt.acf_fields.champ_libre" class="term term-libre">
        {{ cpt.acf_fields.champ_libre }}
      </span>
    </div>
    <h3>{{ decode(cpt.title) }}</h3>
    <template v-if="cpt.acf_fields">
      <p
        v-if="cpt.acf_fields.hasOwnProperty('nom_employeur')"
        class="employeur"
      >
        {{ cpt.acf_fields.nom_employeur }}
      </p>
    </template>
    <template v-if="cpt.acf_fields">
      <p
        v-if="cpt.acf_fields.hasOwnProperty('description_extrait_de_la_page')"
        class="desc-page"
      >
        {{ cpt.acf_fields.description_extrait_de_la_page }}
      </p>
    </template>
    <template v-if="cpt.acf_fields">
      <a
        v-if="cpt.acf_fields.lien_telechargement != null"
        :href="cpt.acf_fields.lien_telechargement"
        class="lien-telechargement"
        target="_blank"
      >
        {{ cpt.acf_fields.texte_du_lien_vers_le_fichier_a_telecharger }}
      </a>
    </template>
    <template v-if="cpt.acf_fields">
      <a
        v-if="cpt.acf_fields.lien_externe != null"
        target="_blank"
        class="lien-telechargement"
        :href="cpt.acf_fields.lien_externe.url"
        >{{ cpt.acf_fields.lien_externe.title }}</a
      >
    </template>
    <div class="buttons-extrait">
      <p v-if="cpt.link" class="cta_btn_lead cta_secondaire">
        <a target="_blank" :href="cpt.link">{{
          dataJson.texte_en_savoir_plus
        }}</a>
      </p>
    </div>
  </div>
</template>

<style></style>
